import axios from 'axios';
import {all, call, fork, put, takeEvery, select} from "redux-saga/effects";

import {
    REQ_MASTER_DRIVER_DATA,
    GET_MASTER_DRIVER_DATA,
    REQ_ADD_MASTER_DRIVER_DATA,
    GET_ADD_MASTER_DRIVER_DATA,
    REQ_EDIT_MASTER_DRIVER_DATA,
    REQ_DELETE_MASTER_DRIVER_DATA,
    SUCCESS_MESSAGE_MASTER_DRIVER,
    ERROR_MESSAGE_MASTER_DRIVER,
    BASE_URL_APIv4,
} from 'constants/ActionTypes';


const key = localStorage.getItem('apiKey')

const getMasterDriverData = async () => {
    
    return await axios.get(`${BASE_URL_APIv4}/user/cmd/simple-select?apiKey=28de3a17-491d-47d1-a7e8-4ea7d8b0b9b7&client=datatables&params={%22company%22:%22255%22}`)
                .then((res) => res)
                .catch((error) => error.response)
}

const getAddMasterDriver = async (data) => {
    const obj = JSON.stringify(data)
    // console.log(obj)
    return await axios.post(`${BASE_URL_APIv4}/user?apiKey=28de3a17-491d-47d1-a7e8-4ea7d8b0b9b7`, obj)
                .then((res) => res)
                .catch((error) => error.response)
}

const getEditMasterDriver = async (data) => {
    const obj = JSON.stringify(data.result);
    return await axios.put(`${BASE_URL_APIv4}/user/id/${data.id}?apiKey=28de3a17-491d-47d1-a7e8-4ea7d8b0b9b7`, obj)
                .then((res) => res)
                .catch((error) => error.response)
}

const getDeleteMasterDriver = async (data) => {
    return await axios.delete(`${BASE_URL_APIv4}/user/id/${data}?apiKey=28de3a17-491d-47d1-a7e8-4ea7d8b0b9b7`)
                .then((res) => res)
                .catch((error) => error.response)
}

export function* setMasterDriverData(){
    try {
        const result = yield call(getMasterDriverData)
        // console.log(result)
        if(result.status == 200){
            const res = result.data.aaData;

            yield put({type: GET_MASTER_DRIVER_DATA, payload: res})
        } else {
            const err = 'Opps! looks like something wrong'  
            // console.log(err)
        }
    } catch (error) {
        // console.log(error)
    }
}

export function* setAddMasterDriver(data){
    
    try {
        // console.log('add new MasterDriver from saga')
        const result = yield call(getAddMasterDriver, data.action)
        // console.log(result)
        if(result.status == 200){
            const success = 'Data Successfuly Created'
            yield put({type: SUCCESS_MESSAGE_MASTER_DRIVER, payload: success})
        }
    } catch (error) {
        const error = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_MASTER_DRIVER, payload: error})
    }
}

export function* setEditMasterDriver(data){
   
    try {
        // console.log('add new MasterDriver from saga')
        // console.log(data.action)
        const result = yield call(getEditMasterDriver, data.action)
        // console.log(result)
        
        if(result.status == 200){
            const success = 'Data Successfuly Updated'
            yield put({type: SUCCESS_MESSAGE_MASTER_DRIVER, payload: success})
        }
    } catch (error) {
        const error = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_MASTER_DRIVER, payload: error})
    }
}

export function* setDeleteMasterDriver(data){
   
    try {
        // console.log('add new MasterDriver from saga')
        // console.log(data.action)
        const result = yield call(getDeleteMasterDriver, data.action)
        // console.log(result)
        if(result.status == 200){
            const success = 'Data Successfuly Deleted'
            yield put({type: SUCCESS_MESSAGE_MASTER_DRIVER, payload: success})
        }
    } catch (error) {
        const error = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_MASTER_DRIVER, payload: error})
    }
}


export function* reqMasterDriverData(){
    yield takeEvery(REQ_MASTER_DRIVER_DATA, setMasterDriverData)
}

export function* reqAddMasterDriver(){
    yield takeEvery(REQ_ADD_MASTER_DRIVER_DATA, setAddMasterDriver)
}

export function* reqEditMasterDriver(){
    yield takeEvery(REQ_EDIT_MASTER_DRIVER_DATA, setEditMasterDriver)
}

export function* reqDeleteMasterDriver(){
    yield takeEvery(REQ_DELETE_MASTER_DRIVER_DATA, setDeleteMasterDriver)
}

export default function* rootSaga() {
    yield all([
        fork(reqMasterDriverData),
        fork(reqAddMasterDriver),
        fork(reqEditMasterDriver),
        fork(reqDeleteMasterDriver),
    ]);
}


// WEBPACK FOOTER //
// ./sagas/MasterDriver.js